import { render, staticRenderFns } from "./ViewLiquidUnclaimedReportTwo.vue?vue&type=template&id=58502870&scoped=true&"
import script from "./ViewLiquidUnclaimedReportTwo.vue?vue&type=script&lang=js&"
export * from "./ViewLiquidUnclaimedReportTwo.vue?vue&type=script&lang=js&"
import style0 from "./ViewLiquidUnclaimedReportTwo.vue?vue&type=style&index=0&id=58502870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58502870",
  null
  
)

export default component.exports